export class RateCategory {
  public id?: number;
  public name: string;
  public shortName: string;
  public coefficient?: number;
  public status?: StatusRemarkType
  constructor(
    id?: number,
    name: string = '',
    shortName: string = '',
    coefficient: number = 0,
    status?: StatusRemarkType
  ) {
    this.id = id
    this.name = name
    this.shortName = shortName
    this.coefficient = coefficient
    this.status = status
  }
}